/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Add_DiscountInputs */

const en_admin_resource_form_add_discount = /** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Discount`)
};

const de_admin_resource_form_add_discount = /** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt hinzufügen`)
};

const es_admin_resource_form_add_discount = /** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir descuento`)
};

const fr_admin_resource_form_add_discount = /** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une remise`)
};

const nl_admin_resource_form_add_discount = /** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korting toevoegen`)
};

/** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */
const it_admin_resource_form_add_discount = en_admin_resource_form_add_discount;

/** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */
const pt_br2_admin_resource_form_add_discount = en_admin_resource_form_add_discount;

/** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */
const pl_admin_resource_form_add_discount = en_admin_resource_form_add_discount;

/** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */
const hu_admin_resource_form_add_discount = en_admin_resource_form_add_discount;

/** @type {(inputs: Admin_Resource_Form_Add_DiscountInputs) => LocalizedString} */
const ro_admin_resource_form_add_discount = en_admin_resource_form_add_discount;

/**
* | output |
* | --- |
* | "Add Discount" |
*
* @param {Admin_Resource_Form_Add_DiscountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_add_discount = /** @type {((inputs?: Admin_Resource_Form_Add_DiscountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Add_DiscountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_add_discount(inputs)
	if (locale === "de") return de_admin_resource_form_add_discount(inputs)
	if (locale === "es") return es_admin_resource_form_add_discount(inputs)
	if (locale === "fr") return fr_admin_resource_form_add_discount(inputs)
	if (locale === "nl") return nl_admin_resource_form_add_discount(inputs)
	if (locale === "it") return it_admin_resource_form_add_discount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_add_discount(inputs)
	if (locale === "pl") return pl_admin_resource_form_add_discount(inputs)
	if (locale === "hu") return hu_admin_resource_form_add_discount(inputs)
	return ro_admin_resource_form_add_discount(inputs)
});
export { admin_resource_form_add_discount as "admin.resource_form.add_discount" }